// extracted by mini-css-extract-plugin
export default {"wrapper":"NbBMEMQHcbDWupObbQFP","pageWrapper":"GpgNkhrL2thW4_T8oEvI"};